import Projects from "../../components/Project/Projects";

export default function ProjectManagerProjects() {
  return (
    <Projects userRole={"Project Manager"} />
  );
}